import { CSVRow, Entity, FieldType, Primitive, validate, validateEmailAddress } from 'gossamer-unified';
import { applyValidation, validateGroupIdList } from './EventUpload';

export interface MemberUploadRow {
  email_address: string;
  groups_to_allocate_to?: string;
  registration_task_definition_id?: string;
}

export const MemberUpload: Entity<MemberUploadRow> = {
  id: 'MemberUpload',
  title: 'Member',
  service: 'main',
  rowLabel: (row: MemberUploadRow) => row.email_address,
  primaryKeyFields: [],
  security: [],
  fields: {
    email_address: {
      seq: 10,
      type: FieldType.Text,
      label: 'Email Address',
      mandatory: true,
      description: "the member's email address",
    },
    groups_to_allocate_to: {
      seq: 20,
      type: FieldType.Text,
      label: 'Id(s) of Group(s) to Add this Member to',
      description: 'must be a list of numbers separated by the "|" character',
      regex: '^[\\d|]+$',
    },
    registration_task_definition_id: {
      seq: 30,
      type: FieldType.Text,
      label: 'Registration Workflow Id',
      description: 'must be a number',
      regex: '^\\d+$',
    },
  },
};

export const memberValidator = (row: CSVRow<MemberUploadRow>): string[] => {
  const out: string[] = [];
  const rowValues = row as Record<string, Primitive>;
  Object.keys(MemberUpload.fields).forEach((fieldId) => {
    const field = MemberUpload.fields[fieldId as keyof MemberUploadRow];
    const value = rowValues[fieldId] as Primitive;
    applyValidation(out, validate(field, value), field.label, value);
  });
  applyValidation(
    out,
    validateEmailAddress(rowValues.email_address as string),
    'Email Address',
    rowValues.email_address,
  );
  applyValidation(
    out,
    validateGroupIdList(row.groups_to_allocate_to),
    'Groups to Allocate To',
    row.groups_to_allocate_to,
  );
  return out;
};
